import Relay from 'react-relay';

export default class AddAgentMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{addAgent}`;
  }

  getVariables() {
    return {
      name: this.props.name,
      email: this.props.email,
      agentId: this.props.agentId
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on AddAgentPayload {
        user {
          type
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        user: this.props.userRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/AddAgentMutation.js
 **/